import { render, staticRenderFns } from "./SetAppSideBar.vue?vue&type=template&id=c153f730&scoped=true"
import script from "./SetAppSideBar.vue?vue&type=script&lang=js"
export * from "./SetAppSideBar.vue?vue&type=script&lang=js"
import style0 from "./SetAppSideBar.vue?vue&type=style&index=0&id=c153f730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c153f730",
  null
  
)

export default component.exports